(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-easter-smash-egg"] && !Shopify.designMode) return;
  try {
    
class CxEasterSmashEgg extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.sectionId = this.closest('[data-section-id]')?.dataset.sectionId || '';
    this.config = this.readConfig();
    this.enableModal = true;
    this.animationDuration = this.readNumber(this.dataset.animationDuration, 560);
    this.eggButtons = Array.from(this.querySelectorAll('.as-smash-egg'));
    this.grid = this.querySelector('.as-smash-grid');
    this.resetButton = this.querySelector('.as-smash-reset');
    this.scrollButton = this.querySelector('.as-smash-scroll');
    this.copyButtons = Array.from(this.querySelectorAll('.as-smash-copy'));
    this.linkButtons = Array.from(this.querySelectorAll('.as-smash-link'));
    this.codeWraps = Array.from(this.querySelectorAll('.as-smash-code-wrap'));
    this.codeNodes = Array.from(this.querySelectorAll('.as-smash-code'));
    this.statusNodes = Array.from(this.querySelectorAll('.as-smash-status'));
    this.titleNodes = Array.from(this.querySelectorAll('.as-smash-title'));
    this.messageNodes = Array.from(this.querySelectorAll('.as-smash-message'));
    this.feedbackNodes = Array.from(this.querySelectorAll('.as-smash-copy-feedback'));
    this.dialog = this.querySelector('.as-smash-modal');
    this.closeButtons = Array.from(this.querySelectorAll('.as-smash-close'));
    this.openedEggs = new Set();
    this.lastTrigger = null;
    this.copyFeedbackTimer = null;
    this.currentEggIndex = null;
    this.revealTimers = [];

    this.bindEvents();
    this.resetBoard();
  }

  disconnectedCallback() {
    this.clearRevealTimers();
    window.clearTimeout(this.copyFeedbackTimer);
    this.closeDialog();
    this.abortController?.abort();
  }

  bindEvents() {
    this.eggButtons.forEach((button) => {
      button.addEventListener('click', this.handleEggClick, { signal: this.signal });
    });

    this.copyButtons.forEach((button) => {
      button.addEventListener('click', this.handleCopyClick, { signal: this.signal });
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.handleCloseClick, { signal: this.signal });
    });

    this.resetButton?.addEventListener('click', this.handleResetClick, { signal: this.signal });
    this.scrollButton?.addEventListener('click', this.handleScrollClick, { signal: this.signal });

    document.addEventListener('shopify:section:load', this.handleSectionLoad, { signal: this.signal });
    document.addEventListener('shopify:section:unload', this.handleSectionUnload, { signal: this.signal });

    if (this.dialog) {
      this.dialog.addEventListener('click', this.handleDialogBackdropClick, { signal: this.signal });
      this.dialog.addEventListener('close', this.handleDialogClose, { signal: this.signal });
      this.dialog.addEventListener('cancel', this.handleDialogCancel, { signal: this.signal });
    }
  }

  readConfig() {
    const configNode = this.querySelector('.as-smash-config');
    if (!configNode) {
      return { eggs: [] };
    }

    try {
      return JSON.parse(configNode.textContent || '{}');
    } catch (_error) {
      return { eggs: [] };
    }
  }

  readNumber(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  handleEggClick = (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const eggIndex = this.readNumber(button.dataset.eggIndex, -1);
    if (eggIndex < 0) return;
    if (this.openedEggs.has(eggIndex)) {
      if (button.dataset.copyCode) {
        this.copyInlineReward(button);
      }
      return;
    }

    const egg = this.config.eggs?.[eggIndex];
    if (!egg) return;

    this.openedEggs.add(eggIndex);
    this.syncResetButtonState();
    button.disabled = true;
    button.classList.add('is-cracking');

    const revealDelay = this.prefersReducedMotion()
      ? Math.max(240, Math.round(this.animationDuration * 0.45))
      : this.animationDuration;
    const timer = window.setTimeout(() => {
      button.classList.remove('is-cracking');
      button.classList.add('is-opened');
      const result = this.buildResult(egg);
      this.applyInlineReward(button, result, eggIndex);
      this.applyResult(result, eggIndex);
      this.pushResultTracking(eggIndex, result);

      if (this.enableModal) {
        this.openDialog(button);
      }
    }, revealDelay);

    this.revealTimers.push(timer);
  };

  buildResult(egg) {
    const winProbability = this.clamp(
      this.readNumber(egg.winProbability, this.readNumber(this.config.defaultWinProbability, 0)),
      0,
      100
    );
    const won = Math.random() * 100 < winProbability;

    if (won) {
      return {
        won: true,
        status: this.config.winStatus || 'Prize unlocked',
        title: egg.prizeTitle || 'Reward unlocked',
        message: egg.prizeContent || '',
        sellingPoint: egg.sellingPoint || this.config.defaultSellingPoint || '',
        code: egg.code || '',
        buttonLabel: egg.buttonLabel || '',
        buttonLink: egg.buttonLink || ''
      };
    }

    return {
      won: false,
      status: this.config.loseStatus || 'Not this one',
      title: egg.loseTitle || this.config.loseTitle || 'Almost there',
      message: egg.loseMessage || this.config.loseMessage || '',
      sellingPoint: egg.sellingPoint || '',
      code: '',
      buttonLabel: '',
      buttonLink: ''
    };
  }

  applyResult(result, eggIndex) {
    this.currentResult = result;
    this.currentEggIndex = eggIndex;
    const composedMessage = result.won && result.sellingPoint
      ? `<p><strong>${this.escapeHtml(result.sellingPoint)}</strong></p>${result.message || ''}`
      : (result.message || '');

    this.setText(this.statusNodes, result.status || '');
    this.setText(this.titleNodes, result.title || '');
    this.setHtml(this.messageNodes, composedMessage);
    this.setCodeState(result.code, result.buttonLabel, result.buttonLink, eggIndex);
    this.clearCopyFeedback();
  }

  applyInlineReward(button, result, eggIndex) {
    const rewardNode = button.querySelector('.as-smash-inline-reward');
    const codeNode = button.querySelector('.as-smash-inline-code');
    const feedbackNode = button.querySelector('.as-smash-inline-copy-feedback');
    const hasCode = Boolean(result.won && result.code);

    button.classList.toggle('has-inline-code', hasCode);
    button.dataset.copyCode = hasCode ? result.code : '';
    button.disabled = !hasCode;
    this.setEggTracking(button, eggIndex, hasCode ? 'copy_inline' : 'click');

    if (!rewardNode || !codeNode || !feedbackNode) return;

    rewardNode.hidden = !hasCode;
    codeNode.textContent = hasCode ? result.code : '';
    feedbackNode.textContent = hasCode ? 'Tap to copy' : '';
  }

  setText(nodes, value) {
    nodes.forEach((node) => {
      node.textContent = value;
    });
  }

  setHtml(nodes, value) {
    nodes.forEach((node) => {
      node.innerHTML = value;
    });
  }

  setCodeState(code, buttonLabel, buttonLink, eggIndex = this.currentEggIndex) {
    const hasCode = Boolean(code);

    this.codeWraps.forEach((node) => {
      node.hidden = !hasCode;
    });

    this.codeNodes.forEach((node) => {
      node.textContent = code || '';
    });

    this.copyButtons.forEach((button) => {
      button.disabled = !hasCode;
      button.dataset.copyCode = code || '';
      button.textContent = this.config.copyButtonLabel || 'Copy code';
    });

    this.linkButtons.forEach((link) => {
      const hasLink = hasCode && buttonLabel && buttonLink;
      link.hidden = !hasLink;
      link.textContent = hasLink ? buttonLabel : '';
      link.href = hasLink ? buttonLink : '#';
    });

    this.setResultActionTracking(eggIndex);
  }

  handleCopyClick = async (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const code = button.dataset.copyCode || '';
    if (!code) return;

    const copied = await this.copyToClipboard(code);
    if (!copied) return;

    const successLabel = this.config.copySuccessLabel || 'Copied';
    this.copyButtons.forEach((copyButton) => {
      copyButton.textContent = successLabel;
    });
    this.feedbackNodes.forEach((node) => {
      node.textContent = successLabel;
    });

    window.clearTimeout(this.copyFeedbackTimer);
    this.copyFeedbackTimer = window.setTimeout(() => {
      this.clearCopyFeedback();
    }, 1800);
  };

  clearCopyFeedback() {
    this.copyButtons.forEach((button) => {
      button.textContent = this.config.copyButtonLabel || 'Copy code';
    });
    this.feedbackNodes.forEach((node) => {
      node.textContent = '';
    });

    this.eggButtons.forEach((button) => {
      const feedbackNode = button.querySelector('.as-smash-inline-copy-feedback');
      if (feedbackNode && button.classList.contains('has-inline-code')) {
        feedbackNode.textContent = 'Tap to copy';
      }
    });
  }

  async copyInlineReward(button) {
    const code = button.dataset.copyCode || '';
    if (!code) return;

    const copied = await this.copyToClipboard(code);
    if (!copied) return;

    const successLabel = this.config.copySuccessLabel || 'Copied';
    const feedbackNode = button.querySelector('.as-smash-inline-copy-feedback');

    if (feedbackNode) {
      feedbackNode.textContent = successLabel;
    }

    window.clearTimeout(this.copyFeedbackTimer);
    this.copyFeedbackTimer = window.setTimeout(() => {
      if (feedbackNode && button.classList.contains('has-inline-code')) {
        feedbackNode.textContent = 'Tap to copy';
      }
    }, 1800);
  }

  async copyToClipboard(value) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch (_error) {
        return false;
      }
    }

    const tempInput = document.createElement('textarea');
    tempInput.value = value;
    tempInput.setAttribute('readonly', '');
    tempInput.style.position = 'absolute';
    tempInput.style.left = '-9999px';
    this.appendChild(tempInput);
    tempInput.select();

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (_error) {
      copied = false;
    }

    tempInput.remove();
    return copied;
  }

  handleResetClick = () => {
    this.resetBoard();
  };

  getEggNumber(eggIndex) {
    if (eggIndex === null || eggIndex === undefined || eggIndex === '') {
      return -1;
    }

    return this.readNumber(eggIndex, -1) + 1;
  }

  setEggTracking(button, eggIndex, action = 'click') {
    if (!(button instanceof HTMLElement)) return;

    const eggNumber = this.getEggNumber(eggIndex);
    if (eggNumber <= 0) return;

    button.dataset.event = action === 'copy_inline'
      ? (this.config.trackEventCopyClick || 'fl_smash_egg_copy_click')
      : (this.config.trackEventClick || 'fl_smash_egg_click');
    button.dataset.id = 'fl_click';
    button.dataset.type = action === 'copy_inline' ? `egg_${eggNumber}_copy_inline` : `egg_${eggNumber}`;
  }

  setResultActionTracking(eggIndex) {
    const eggNumber = this.getEggNumber(eggIndex);
    const copyType = eggNumber > 0 ? `egg_${eggNumber}_copy_modal` : 'copy_modal';
    const ctaType = eggNumber > 0 ? `egg_${eggNumber}_cta` : 'cta';

    this.copyButtons.forEach((button) => {
      button.dataset.event = this.config.trackEventCopyClick || 'fl_smash_egg_copy_click';
      button.dataset.id = 'fl_click';
      button.dataset.type = copyType;
    });

    this.linkButtons.forEach((link) => {
      link.dataset.event = this.config.trackEventCtaClick || 'fl_smash_egg_cta_click';
      link.dataset.id = 'fl_click';
      link.dataset.type = ctaType;
    });
  }

  pushResultTracking(eggIndex, result) {
    const eggNumber = this.getEggNumber(eggIndex);
    if (eggNumber <= 0) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: this.config.trackEventResult || 'fl_smash_egg_result',
      egg_index: eggNumber,
      result: result.won ? 'win' : 'lose',
      has_code: Boolean(result.code)
    });
  }

  syncResetButtonState() {
    if (!(this.resetButton instanceof HTMLButtonElement)) return;
    this.resetButton.disabled = this.openedEggs.size === 0;
  }

  handleScrollClick = () => {
    if (!this.grid) return;
    this.grid.scrollIntoView({
      behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'center'
    });
  };

  handleCloseClick = () => {
    this.closeDialog();
  };

  handleDialogBackdropClick = (event) => {
    if (event.target === this.dialog) {
      this.closeDialog();
    }
  };

  handleDialogClose = () => {
    this.focusWithoutScroll(this.lastTrigger);
  };

  handleDialogCancel = (event) => {
    event.preventDefault();
    this.closeDialog();
  };

  openDialog(trigger) {
    if (!(this.dialog instanceof HTMLDialogElement)) return;
    if (this.dialog.open) {
      return;
    }

    this.lastTrigger = trigger;
    this.dialog.showModal();
    const focusTarget = this.closeButtons.find((button) => !button.hidden && !button.disabled) || this.dialog;
    this.focusWithoutScroll(focusTarget);
  }

  closeDialog() {
    if (this.dialog instanceof HTMLDialogElement && this.dialog.open) {
      this.dialog.close();
    }
  }

  handleSectionLoad = (event) => {
    if (event?.detail?.sectionId !== this.sectionId) return;
    this.resetBoard();
  };

  handleSectionUnload = (event) => {
    if (event?.detail?.sectionId !== this.sectionId) return;
    this.clearRevealTimers();
    this.closeDialog();
  };

  resetBoard() {
    this.clearRevealTimers();
    this.openedEggs.clear();
    this.closeDialog();
    this.currentEggIndex = null;

    this.eggButtons.forEach((button) => {
      button.disabled = false;
      button.dataset.copyCode = '';
      button.classList.remove('is-cracking', 'is-opened', 'has-inline-code');
      this.setEggTracking(button, button.dataset.eggIndex, 'click');

      const rewardNode = button.querySelector('.as-smash-inline-reward');
      const codeNode = button.querySelector('.as-smash-inline-code');
      const feedbackNode = button.querySelector('.as-smash-inline-copy-feedback');

      if (rewardNode) rewardNode.hidden = true;
      if (codeNode) codeNode.textContent = '';
      if (feedbackNode) feedbackNode.textContent = 'Tap to copy';
    });

    this.setText(this.statusNodes, this.config.readyStatus || 'Ready');
    this.setText(this.titleNodes, this.config.readyTitle || 'Pick an egg');
    this.setHtml(this.messageNodes, this.config.readyMessage || '');
    this.setCodeState('', '', '', null);
    this.clearCopyFeedback();
    this.syncResetButtonState();
  }

  clearRevealTimers() {
    this.revealTimers.forEach((timer) => {
      window.clearTimeout(timer);
    });
    this.revealTimers = [];
  }

  prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  escapeHtml(value) {
    const span = document.createElement('span');
    span.textContent = value;
    return span.innerHTML;
  }

  focusWithoutScroll(node) {
    if (!(node instanceof HTMLElement)) return;

    try {
      node.focus({ preventScroll: true });
    } catch (_error) {
      node.focus();
    }
  }
}

if (!customElements.get('cx-easter-smash-egg')) {
  customElements.define('cx-easter-smash-egg', CxEasterSmashEgg);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-referral-ac90277-prism-hero"] && !Shopify.designMode) return;
  try {
    
class CxPrismReferralHero extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.views = this.querySelectorAll('[data-view]');
    this.form = this.querySelector('[data-referral-form]');
    this.emailInput = this.form?.elements?.email || null;
    this.linkInput = this.querySelector('[data-referral-link]');
    this.copyBtn = this.querySelector('[data-copy-btn]');
    this.statusEls = this.querySelectorAll('[data-status]');
    this.xLink = this.querySelector('[data-share-x]');
    this.fbLink = this.querySelector('[data-share-fb]');
    this.mailLink = this.querySelector('[data-share-email]');

    this.campaignId = this.dataset.campaignId || '';
    this.origin = this.dataset.referralOrigin || '';
    this.inviteBase = this.dataset.inviteBase || '';
    this.email = this.dataset.customerEmail || '';
    this.copyLabel = this.dataset.copyLabel || 'Copy';
    this.copiedLabel = this.dataset.copiedLabel || 'Copied';
    this.shareSubject = this.dataset.shareSubject || '';
    this.shareBody = this.dataset.shareBody || '';

    this._onSubmit = this._handleSubmit.bind(this);
    this._onCopy = this._handleCopy.bind(this);

    this.form?.addEventListener('submit', this._onSubmit);
    this.copyBtn?.addEventListener('click', this._onCopy);

    this._boot();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this._onSubmit);
    this.copyBtn?.removeEventListener('click', this._onCopy);
  }

  async _boot() {
    if (!this.campaignId || !this.origin || !this.inviteBase) {
      this._show('ended');
      return;
    }

    this._show('loading');

    try {
      const url = `${this.origin}/referral/api/customer/campaigns/${encodeURIComponent(this.campaignId)}/status`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      if (data?.status !== 'enabled') {
        this._show('ended');
        return;
      }

      if (this.email) {
        await this._provision(this.email);
      } else {
        this._show('form');
        this._setStatus('');
      }
    } catch (err) {
      this._show('form');
      this._setStatus(this.dataset.errorText || 'Service unavailable. Please try again.', 'error');
    }
  }

  async _handleSubmit(e) {
    e.preventDefault();
    const email = this.emailInput?.value?.trim();
    if (!email) {
      this._setStatus(this.dataset.errorText || 'Please enter your email.', 'error');
      return;
    }
    await this._provision(email);
  }

  async _provision(email) {
    this._show('loading');
    this._setStatus(this.dataset.loadingText || 'Generating link…');

    try {
      const url = `${this.origin}/referral/api/customer/campaigns/${encodeURIComponent(this.campaignId)}/inviters`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const coupon = data?.coupon;
      if (!coupon) throw new Error('No coupon returned');

      const link = `${this.inviteBase}/${encodeURIComponent(coupon)}`;
      if (this.linkInput) this.linkInput.value = link;
      this._buildShareLinks(link);
      this._show('ready');
      this._setStatus(this.dataset.readyText || 'Your link is ready.', 'success');
    } catch (err) {
      this._show('form');
      this._setStatus(this.dataset.errorText || 'Could not generate your link. Please try again.', 'error');
    }
  }

  _show(name) {
    this.views.forEach(v => {
      v.hidden = v.dataset.view !== name;
    });
  }

  _setStatus(msg, tone) {
    this.statusEls.forEach(el => {
      el.textContent = msg;
      el.classList.toggle('text-danger', tone === 'error');
      el.classList.toggle('text-success', tone === 'success');
    });
  }

  _buildShareLinks(link) {
    const body = this.shareBody;

    if (this.xLink) {
      const u = new URL('https://twitter.com/intent/tweet');
      u.searchParams.set('text', body);
      u.searchParams.set('url', link);
      this.xLink.href = u.toString();
    }

    if (this.fbLink) {
      const u = new URL('https://www.facebook.com/sharer/sharer.php');
      u.searchParams.set('u', link);
      u.searchParams.set('quote', body);
      this.fbLink.href = u.toString();
    }

    if (this.mailLink) {
      const u = new URL('mailto:');
      u.searchParams.set('subject', this.shareSubject);
      u.searchParams.set('body', `${body}\n\n${link}`);
      this.mailLink.href = u.toString();
    }
  }

  async _handleCopy() {
    const val = this.linkInput?.value?.trim();
    if (!val || !this.copyBtn) return;

    let ok = false;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(val);
        ok = true;
      }
    } catch (_) {}

    if (!ok) {
      const ta = document.createElement('textarea');
      ta.value = val;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { ok = document.execCommand('copy'); } catch (_) {}
      ta.remove();
    }

    this.copyBtn.textContent = ok ? this.copiedLabel : this.copyLabel;
    setTimeout(() => { if (this.copyBtn) this.copyBtn.textContent = this.copyLabel; }, 1800);
  }
}

if (!customElements.get('cx-prism-referral-hero')) {
  customElements.define('cx-prism-referral-hero', CxPrismReferralHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var $url = document.querySelector('.as-finishes-gallery-script')
      if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
        window._finishesGallery = $url.value
        var $script = document.createElement('script')
        $script.src = window._finishesGallery
        $script.defer = "defer"
        document.body.appendChild($script)
      }
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-screen-zoom-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-full-screen-zoom-text-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  var $gallerys = document.querySelectorAll('.as-gallery-v2');
  var galleryWrapper = document.querySelector('.as-gallery-v2-wrapper')
  var enableForcedScrolling = galleryWrapper?.dataset.enableForcedScrolling
  var $navBar = document.querySelector('.as-sticky-nav-bar-pdp');
  var screenHeight = window.innerHeight;
  var navBarHeight = $navBar.clientHeight;
  var visibleHeight = screenHeight - navBarHeight;

  if (enableForcedScrolling === 'true') {
    $gallerys.forEach(function($gallery) {
      var $galleryWrapper = $gallery.querySelector('.as-gallery-v2-wrapper');
      if ($galleryWrapper == null) return;
      var $galleryMainContent = $galleryWrapper.querySelector('.as-gallery-main-content');
      if ($galleryMainContent == null) return;
      var totalHeight = $galleryWrapper.clientHeight;
      var $cardContainer = $galleryWrapper.querySelector('.as-card-container');
      if ($cardContainer == null) return;
      var mainContentOffsetTop = $galleryWrapper.querySelector('.as-card-container').offsetTop;
      var mainContentHeight = $galleryMainContent.clientHeight;
      var top = 0;
      if (totalHeight > visibleHeight) {
        if (mainContentHeight > visibleHeight) {
          top = (mainContentOffsetTop - ((mainContentHeight - visibleHeight) / 2)) * -1 + 'px';
        } else {
          top = (mainContentOffsetTop - ((visibleHeight - mainContentHeight) / 2)) * -1 + 'px';
        }
      } else {
        top = (visibleHeight - totalHeight) / 2 + 'px';
      }
      $gallery.style.setProperty('--top', top);
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-and-floating-card"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-and-floating-card-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab-pdp-z70u"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-main-product-v2-script');
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value;
      var $script = document.createElement('script');
      $script.src = window.productV2;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-grid"] && !Shopify.designMode) return;
  try {
    
  const gradientBlock = document.getElementById('gradientBlock');
  const container = document.getElementById('gradientContainer');
  if (gradientBlock == null) return;

  // 页面加载时将色块居中
  function centerGradientBlock() {
    const containerRect = container.getBoundingClientRect();
    const x = (containerRect.width - gradientBlock.offsetWidth) / 2;
    const y = (containerRect.height - gradientBlock.offsetHeight) / 2;
    gradientBlock.style.left = `${x}px`;
    gradientBlock.style.top = `${y}px`;
  }

  // 检查视口大小
  function checkViewportSize() {
    if (window.innerWidth >= 768) {
      // 初始化色块位置
      centerGradientBlock();

      // 处理鼠标移动事件
      document.addEventListener('mousemove', handleMouseMove);
    } else {
      // 移除鼠标移动事件监听器
      document.removeEventListener('mousemove', handleMouseMove);
    }
  }

  // 处理鼠标移动事件
  function handleMouseMove(event) {
    const containerRect = container.getBoundingClientRect();
    const x = event.clientX - containerRect.left - gradientBlock.offsetWidth / 2;
    const y = event.clientY - containerRect.top - gradientBlock.offsetHeight / 2;

    // 限制色块在容器内
    gradientBlock.style.left = `${Math.max(0, Math.min(containerRect.width - gradientBlock.offsetWidth, x))}px`;
    gradientBlock.style.top = `${Math.max(0, Math.min(containerRect.height - gradientBlock.offsetHeight, y))}px`;
  }

  // 初始化视口大小检查
  checkViewportSize();

  // 监听窗口大小变化
  window.addEventListener('resize', checkViewportSize);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-multicolumn-swiper-script')
    if (!window.MulticolumnSwipers && $url) {
      window.MulticolumnSwipers = $url.value

      var $script = document.createElement('script')
      $script.src = window.MulticolumnSwipers
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-pdp-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-unlock-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-scroll-unlock-cards-script')
    if (!window.creativeGsap && $url) {
      window.creativeGsap = $url.value
  
      var $script = document.createElement('script')
      $script.src = window.creativeGsap
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-v2-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner-z70"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
